import React from "react"
import { BackIcon, Box, Button, ForwardIcon } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { Link as RouterLink } from "react-router-dom"

export function InsuranceRecoveryFooter({ onContinue }: { onContinue: () => void }): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        inlineSize: "100%",
        gap: theme.spacing(theme.tokens.spacing.sm)
      })}
    >
      <Button component={RouterLink} to="/care-team" variant="text" color="secondary" startIcon={<BackIcon />}>
        <FormattedMessage defaultMessage="Back to care team" />
      </Button>
      {/* Testing: keep self-pay available here; handle unavailable self-pay in a follow-up. */}
      <Button variant="contained" color="secondary" onClick={onContinue} endIcon={<ForwardIcon />}>
        <FormattedMessage defaultMessage="Pay out of pocket" />
      </Button>
    </Box>
  )
}
